<template>
  <div
    class="rating-stars-container d-flex align-items-center"
  >
    <meta v-if="renderSchemaMeta" itemprop="ratingValue" :content="rating">
    <div v-if="!isPublicMode" class="d-flex align-items-center">
      <div
        v-for="currentStarIndex in starCount"
        :key="'unfilled_' + currentStarIndex"
        class="star-icon unfilled"
        :class="{
          'cursor-pointer': isRatingEnabled && allowEdit,
          'alternate-color': isAlternateColor,
        }"
        @mouseenter="allowEdit ? latestHoveredStarIndex = currentStarIndex : null"
        @mouseleave="allowEdit ? latestHoveredStarIndex = latestStarClicked : null"
        @click="rateClicked"
      />
    </div>
    <div class="filled-stars-container d-flex h-100 align-items-center" :class="{'stars-distance' : isPublicMode}">
      <div
        v-for="currentFilledStarIndex in frontStarCount"
        :key="'filled_' + currentFilledStarIndex"
      >
        <div v-if="isPublicMode">
          <div class="star-svg" />
        </div>
        <div
          v-else-if="!isRatingEnabled || (isRatingEnabled && currentFilledStarIndex <= latestHoveredStarIndex)"
          class="star-icon filled"
          :class="{
            'alternate-color': isAlternateColor,
          }"
        />
      </div>
    </div>
    <div
      v-if="clearButtonNeeded"
      class="ms-1"
    >
      <span
        class="badge bg-danger"
        :class="{'cursor-pointer': allowEdit}"
        @click="clearRate()"
      >
        <i class="bi bi-star" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    /**
     * termék jelenlegi értékelése
     *
     * nem kötelező, mert amikor akarunk értékelni akkor nem kell neki szám, és ennek kell a current value: latestStarClicked
     *
     * @type {number}
     */
    rating: {
      type: Number,
      default: 0,
    },
    /**
     * értékelés engedélyezve van-e
     *
     * @type {boolean}
     */
    isRatingEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * alternativ színű csillagok legyenek-e
     * ha igen akkor kék, ha nem akkor fekete
     *
     * @type {boolean}
     */
    isAlternateColor: {
      type: Boolean,
      default: false,
    },
    /**
     * legutobb kattintott csillag száma, csak értékeléskor. ha nem interaktiv (nem értékelhető, csak jelzés) akkor a rating kell
     *
     * @type {number}
     */
    latestStarClicked: {
      type: Number,
      default: 0,
    },
    /**
     * Clear gomb kell e
     */
    clearButtonNeeded: {
      type: Boolean,
      default: false,
    },
    /**
     * Publikus módban használjuk-e a kompoenst.
     * Ez alapján eltér design-ban és müködésben is.
     */
    isPublicMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Engedélyezzük-e a szerkesztést?
     */
    allowEdit: {
      type: Boolean,
      default: false,
    },
    /**
     * Megjelenítse-e a schema.org-hoz tartozó meta elemet
     */
    renderSchemaMeta: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'rateClicked',
  ],
  data() {
    return {
      /**
       * összes csillag száma
       *
       * @type {number}
       */
      starCount: 5,
      /**
       * leugotbb hoverelt csillag indexe
       *
       * @type {number}
       */
      latestHoveredStarIndex: 0,
    }
  },
  computed: {
    /**
     * szükséges szines csillagok száma
     *
     * @type {number}
     */
    frontStarCount() {
      return this.isRatingEnabled ? 5 : this.rating
    },
  },
  created() {
    this.latestHoveredStarIndex = this.latestStarClicked
  },
  methods: {
    /**
     * kattintottunk a csillagon, ha engedélyezve van akkor kiküldük az eventet
     */
    rateClicked() {
      if (!this.isRatingEnabled) {
        return
      }
      this.$emit('rateClicked', this.latestHoveredStarIndex)
    },
    /**
     * Csillagok törlése
     */
    clearRate() {
      if (!this.allowEdit) {
        return
      }
      this.latestHoveredStarIndex = 0
      this.$emit('rateClicked', this.latestHoveredStarIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
.rating-stars-container {
  position: relative;

  .filled-stars-container {
    position: absolute;
    top: 0;
    left: 0;
  }

  .stars-distance {
    position: relative;
  }

  .star-svg {
    width: 16px;
    height: 16px;
    background-image: url("@shared/assets/star_rate_sm.svg");
  }

  .star-icon {
    width: 15px;
    height: 15px;
    background-image: url("@shared/assets/svg/rate-star.svg");
    background-size: 15px;
    background-position: center;
    background-repeat: no-repeat;

    &.unfilled {
      z-index: 1;
    }

    &.filled {
      background-image: url("@shared/assets/svg/rate-star-filled.svg");
    }

    &.alternate-color {
      filter: invert(38%) sepia(82%) saturate(4516%) hue-rotate(208deg) brightness(99%) contrast(104%);
    }
  }
}
</style>
